// extracted by mini-css-extract-plugin
export default {"stories-user-feed":"StoriesCardsUserFeedCommon_stories-user-feed__+uAI1","stories-user-feed__cards":"StoriesCardsUserFeedCommon_stories-user-feed__cards__qJ4iL"};